var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Form_footer"},[_c('span',{staticClass:"left"},[_vm._v("第三方账号")]),_c('div',{staticClass:"right",on:{"click":_vm.gotoWxlogin}},[_c('img',{attrs:{"src":"https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/icons/weixin%20%281%29.png","alt":""}}),_c('span',[_vm._v("微信")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }